import { ErrorBanner } from "../components/ErrorBanner";
import { SectionLabel } from "../components/SectionLabel";
import { Skeleton } from "../components/Skeleton";
import { useReference } from "../lib/queries";
import { fonts, radius, shadow, tokens } from "../styles/theme";

function fmtRange(min: number | null, max: number | null, unit: string): string {
  if (min === null && max === null) return "—";
  if (min === null) return `≤ ${max}${unit}`;
  if (max === null) return `≥ ${min}${unit}`;
  if (min === max) return `${min}${unit}`;
  return `${min}–${max} ${unit}`;
}

export function ReferenceView() {
  const reference = useReference();

  if (reference.isLoading) return <Skeleton count={5} height={48} />;
  if (reference.isError)
    return (
      <ErrorBanner message={`Failed to load reference: ${(reference.error as Error).message}`} />
    );

  return (
    <div>
      <SectionLabel>Seeding rates · 1020 tray</SectionLabel>
      <div
        style={{
          border: `1px solid ${tokens.line}`,
          borderRadius: radius.md,
          background: tokens.card,
          boxShadow: shadow.xs,
          overflowX: "auto",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.5fr 0.8fr 0.8fr 0.6fr 0.8fr 0.8fr",
            gap: "8px",
            padding: "10px 14px",
            background: tokens.sunken,
            fontSize: "10px",
            letterSpacing: "0.14em",
            color: tokens.muted,
            fontWeight: 600,
            textTransform: "uppercase",
            borderBottom: `1px solid ${tokens.line}`,
            minWidth: "600px",
          }}
        >
          <span>Crop</span>
          <span>Seed</span>
          <span>Soak</span>
          <span>Blackout</span>
          <span>Harvest</span>
          <span>Yield</span>
        </div>
        {(reference.data ?? []).map((r, i, arr) => (
          <div
            key={r.crop}
            style={{
              display: "grid",
              gridTemplateColumns: "1.5fr 0.8fr 0.8fr 0.6fr 0.8fr 0.8fr",
              gap: "8px",
              padding: "12px 14px",
              borderBottom: i === arr.length - 1 ? "none" : `1px solid ${tokens.line}`,
              fontSize: "13px",
              color: tokens.inkSoft,
              minWidth: "600px",
              fontFamily: fonts.mono,
            }}
          >
            <span
              style={{
                color: tokens.ink,
                fontFamily: fonts.body,
                fontWeight: 500,
              }}
            >
              {r.crop}
            </span>
            <span>{fmtRange(r.seed_oz_min, r.seed_oz_max, "oz")}</span>
            <span style={{ color: tokens.muted }}>
              {r.soak_hours > 0 ? `${r.soak_hours}h` : "No soak"}
            </span>
            <span>{r.blackout_days}d</span>
            <span>{`${r.harvest_days_min}–${r.harvest_days_max}d`}</span>
            <span style={{ color: tokens.sageDeep, fontWeight: 500 }}>
              {fmtRange(r.yield_oz_min, r.yield_oz_max, "oz")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
